import { usePunditUserContext } from "@/react/contexts";

export const useIsConnectCoreEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.connect_core_enabled);
};
